import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import authEN from './locales/en/auth.json';
import commonEN from './locales/en/common.json';
import coursesEN from './locales/en/courses.json';
import courseDetailsEN from './locales/en/course-details.json';
import mentorsEN from './locales/en/mentors.json';
import cohortsEN from './locales/en/cohorts.json';
import cohortCreateEN from './locales/en/cohort-create.json';
import landingEN from './locales/en/landing.json';
import studentsEN from './locales/en/students.json';
import journeyEN from './locales/en/journey.json';
import evaluationEN from './locales/en/evaluation.json';

i18n.use(initReactI18next).init({
    resources: {
        en: {
            common: commonEN,
            auth: authEN,
            courses: coursesEN,
            'course-details': courseDetailsEN,
            mentors: mentorsEN,
            cohorts: cohortsEN,
            'cohort-create': cohortCreateEN,
            landing: landingEN,
            students: studentsEN,
            journey: journeyEN,
            evaluation: evaluationEN,
        },
    },
    lng: 'en',
    fallbackLng: 'en',
    defaultNS: 'common',
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;